import React, { useState,useEffect } from "react";
import { url } from "../../App";
import axios from "axios";
import Credin from "../../assets/Credin Logo (1).svg";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const labels = {
  ENGLISH: {
    enterMobileNumber: "Enter Mobile Number",
  },
  HINDI: {
    enterMobileNumber: "मोबाइल नंबर दर्ज करें",
  },
  GUJARATI: {
    enterMobileNumber: "મોબાઈલ નંબર દાખલ કરો",
  }
};

export default function Page1() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const code = localStorage.getItem("CodeCPV");
  const [data, setData] = useState([]);
  const [mobileNumberPdf, setMobileNumberPdf] = useState("");
  const [cpvLanguage, setCpvLanguage] = useState("");
  const [number, setnumber] = useState("");

  useEffect(() => {
    setOpen(true);
    axios
      .post(url + "/api/fetch/cpv/data", {
        createdBy: code,
      })
      .then((res) => {
        setOpen(false);
        console.log(res);
        if (res.data.auth === true) {
          setData(res.data.data.reverse());
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
      });
  }, [code]);

  const handleProceed = (e) => {
    e.preventDefault();
    localStorage.setItem("number", number);
    navigate("/2");
  };

  const handleClick = () => {
    navigate("/create");
  };

  const handleDownload = (mobileNumber) => {
    setOpen(true);
    console.log(mobileNumber);
    axios
      .post(url + "/api/fetch/cpv/pdf", {
        mobileNumber: mobileNumber,
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === true) {
          const downloadLink = document.createElement("a");
          const linkSource = `data:application/pdf;base64,${res.data.base64}`;
          const fileName = `CPV_${res.data.mobileNumber}`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setOpen(false);
        } else {
          setOpen(false);
          toast.error("Please enter valid Mobile Number or Loan Id");
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
      });
  };

  const getLabel = (labelKey) => {
    return labels[cpvLanguage]?.[labelKey] || labels.ENGLISH[labelKey];
  };

  const handleCpvLanguage = (e) => {
    console.log(e.target.value)
    setCpvLanguage(e.target.value);
    localStorage.setItem("cpvLanguage", e.target.value); 
  };

  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <form onSubmit={handleProceed}>
          <div>
            <label>
            Choose Language
              <span style={{ color: "red" }}>*</span>
            </label>
            <br></br>

            <select
              className="nbfc-form-control"
              onChange={handleCpvLanguage}
              required
            >
              <option value="">Select </option>
              <option value="HINDI">Hindi</option>
              <option value="ENGLISH">English</option>
              <option value="GUJARATI">Gujarati</option>
            </select>
          </div>
          <div className="div-login">
            <label>
            {getLabel("enterMobileNumber")} <span style={{ color: "red" }}>*</span>
            </label>
            <input
              value={number}
              onChange={(e) => setnumber(e.target.value)}
              type="number"
              required
              style={{ height: "2rem" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
      <div>
        {localStorage.getItem("CodeCPV") === "UTPL01" ||
          localStorage.getItem("CodeCPV") === "UTPL98" ||
          localStorage.getItem("CodeCPV") === "UTPL167" ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button className="btn-login" onClick={() => handleClick()}>
              Create User
            </button>
          </div>
        ) : (
          ""
        )}
        <div style={{ height: "15rem", overflow: "auto", marginTop: "1rem" }}>
          <table className="pdf-table">
            <thead>
              <tr>
                <th>{data?.some((a) => a?.mobileNumber) ? "Mobile Number" : "Loan ID"}</th>
                <th>CPV Pdf</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((a, index) => {
                return (
                  <tr key={index}>
                    <td>{a?.mobileNumber ? a.mobileNumber : a.uniqueId}</td>
                    <td>
                      <button
                        className="btn-login"
                        onClick={() => handleDownload(a?.mobileNumber ? a.mobileNumber : a.uniqueId)}
                      >
                        Download
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <input
          type="number"
          placeholder="Mobile Number/Loan Id"
          style={{ padding: ".4rem 1rem" }}
          value={mobileNumberPdf}
          onChange={(e) => setMobileNumberPdf(e.target.value)}
        />
        <button
          className="btn-login"
          style={{ marginLeft: ".5rem" }}
          onClick={() => handleDownload(mobileNumberPdf)}
        >
          Download PDF
        </button>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
    </div>
  );
}
